import request from '@/service/request'
enum Api {
  GET_PHONE = '/statistic/getPhone'
}

export default class getPhoneService {
  /**
   * 获取明文手机号
   * @param data
   * @returns
   */
  static getPhone(data: any): Promise<any> {
    return request.post(Api.GET_PHONE, data)
  }
  /**
   * 获取明文邮箱
   * @param data
   * @returns
   */
  static getEmail(data: any): Promise<any> {
    return request.post('/statistic/getEmail', data)
  }
}
